import React, { useState } from 'react';
import { Modal, Section, SectionTitle, Typography } from 'common/components';
import { ChevronRightIcon } from '@fronton/icons-react';
import { createElementKey, removeSpecialCharacters } from 'utils';
import { KITCHEN_ELEMENT_BLOCK } from 'landings/kitchen/kitchen-constants';
import { analyticsUtils } from 'utils/analytics-utils';
import {
  newKitchenHeaderGrid,
  newKitchenHeaderItem,
  newKitchenHeaderItemContent,
  newKitchenHeaderItemIcon,
  newKitchenHeaderItemIconWrapper,
  newKitchenHeaderItemImage,
  newKitchenHeaderItemText,
  newKitchenHeaderModal,
  newKitchenHeaderSection,
  newKitchenHeaderText,
  newKitchenHeaderTitle,
} from './new-kitchen-header-styles';
import { NEW_KITCHEN_HEADER_ITEMS, NewKitchenHeaderItemStructure } from './new-kitchen-header-constants';

export const NewKitchenHeader: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [activeItem, setActiveItem] = useState<NewKitchenHeaderItemStructure | null>(null);

  const handleItemClick = (item: NewKitchenHeaderItemStructure) => () => {
    setActiveItem(item);
    setIsModalOpen(true);

    analyticsUtils.clickButtonEvent(
      KITCHEN_ELEMENT_BLOCK,
      'Кухни под ваши размеры',
      removeSpecialCharacters(item.text)
    );

    analyticsUtils.sendEvent('GA:show', {
      elementType: 'block',
      elementBlock: KITCHEN_ELEMENT_BLOCK,
      elementText: `${removeSpecialCharacters(item.text)} / modal`,
      elementName: 'Модальное окно',
    });
  };

  return (
    <Section className={newKitchenHeaderSection}>
      <SectionTitle className={newKitchenHeaderTitle} as="h1">
        Кухни под ваши размеры быстро и&nbsp;выгодно
      </SectionTitle>
      <Typography className={newKitchenHeaderText} variant="l" size="body_long">
        Сделаем дизайн-проект, поможем подобрать товары, привезём и&nbsp;установим кухню
      </Typography>
      <ul className={newKitchenHeaderGrid}>
        {NEW_KITCHEN_HEADER_ITEMS.map((item, index) => (
          <li key={createElementKey('header-item', index)}>
            <button className={newKitchenHeaderItem} onClick={handleItemClick(item)}>
              <img
                className={newKitchenHeaderItemImage}
                src={item.icon.src}
                alt={item.icon.alt}
                width="36"
                height="36"
              />
              <div className={newKitchenHeaderItemContent}>
                <Typography className={newKitchenHeaderItemText} variant="m" size="body_long">
                  {item.text}
                </Typography>
                <div className={newKitchenHeaderItemIconWrapper}>
                  <ChevronRightIcon
                    className={newKitchenHeaderItemIcon}
                    type="outline"
                    size="l"
                    color="text-minor"
                  />
                </div>
              </div>
            </button>
          </li>
        ))}
      </ul>

      {activeItem && (
        <Modal
          className={newKitchenHeaderModal}
          onClose={() => setIsModalOpen(false)}
          show={isModalOpen}
          size="m"
          variant="curtain">
          <activeItem.modal onCloseModal={() => setIsModalOpen(false)} />
        </Modal>
      )}
    </Section>
  );
};
